export default "__VITE_ASSET__CX3uhOat__"